module.exports = __webpack_public_path__ + "img/upload_image.4a19785a.png";